import { render } from "./AuthenticationComponent.vue?vue&type=template&id=6e354eda"
import script from "./AuthenticationComponent.vue?vue&type=script&lang=js"
export * from "./AuthenticationComponent.vue?vue&type=script&lang=js"

import "./AuthenticationComponent.vue?vue&type=style&index=0&id=6e354eda&lang=css"

import exportComponent from "D:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__